import { useCallback, useRef } from "react";
import { bindJqueryFolderTreeDraggable } from "./jquery/bindJqueryFolderTreeDraggable.js";
function useJqueryFolderTreeDraggable(options) {
    const optionsRef = useRef(options);
    optionsRef.current = options;
    return useCallback(()=>{
        const { resolveTarget, target, ...rest } = optionsRef.current;
        bindJqueryFolderTreeDraggable({
            ...rest,
            target: resolveTarget?.() ?? target
        });
    }, []);
}
export { useJqueryFolderTreeDraggable };
